export default {
    'apartments.flats': 'meeting_room',
    'apartments.buildings': 'location_city',
    'apartments.investments': 'domain',
    'apartments.leads': 'people',
    'apartments.plans': 'select_all',
    'apartments.resource-bindings': 'compare_arrows',
    'apartments.tags': 'local_offer',
};